import { TranslocoModule } from '@ngneat/transloco';

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';

import { TranslationModule } from '@lib/translation';
import { SnAvatarModule } from '@lib/ui/avatar';
import { SnBadgeModule } from '@lib/ui/badge';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';
import { SnMenuModule } from '@lib/ui/menu';
import { SnTooltipModule } from '@lib/ui/tooltip';

import { SnListComponent, SnListItemComponent, SnDetailsComponent } from './components';
import { SnScrollableItemDirective } from './directives';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    RouterModule,
    MatListModule,
    // Libs
    TranslationModule,
    SnIconModule,
    SnBadgeModule,
    SnMenuModule,
    SnAvatarModule,
    SnTooltipModule,
    SnButtonModule,
  ],
  exports: [MatListModule, SnListComponent, SnDetailsComponent, SnScrollableItemDirective],
  declarations: [
    SnListComponent,
    SnListItemComponent,
    SnDetailsComponent,
    SnScrollableItemDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SnListModule {}
